import React, { useEffect, useState } from "react";
import {
  CompRating,
  Content,
  FormStyle,
  HeaderText,
  Image,
  InputFailForm,
  LeftSection,
  RateDisc,
  RateText,
  RightSection,
  Section,
  StudImage,
  TextDiscretion,
  TitleRaeteng,
} from "./StyledRatingCourse";
import { stud1, stud2, stud4, stud3, stud5, Down } from "./images";
import { RatingComponent } from "../../../Components/Form";
import inputSearchProps from "./inputProps";
import { Fade, Slide, Zoom } from "react-reveal";
import { GET_REQUEST, POST_REQUEST } from "../../../HooksApi/useApi";
import UseGetData from "../../../HookAxios/getdata";
import { USeInsertData } from "../../../HookAxios/postData";
import { useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import { formikProps } from "./dataFormik";
import { useSelector } from "react-redux";
import { ButtonBase } from "@mui/material";
import Dots from "../../../Components/Loader/Dots";
const RatingCourse = () => {
  const token = useSelector((state) => state.Auth.userInfo.token);
  const img = useSelector((state) => state.Auth.userInfo.data.image_path);
  const userName = useSelector((state) => state.Auth.userInfo.data.username);
  const { id } = useParams();
  const [num, setNum] = useState(4);
  const [show, setShow] = useState(true);
  const [dataSub, setDataSub] = useState("");
  const onSubmit = (data) => {
    addRate({
      course_id: id,
      ...data,
    });
    setDataSub({
      rate: data.rating,
      commit: data.comment,
    });

    setShow(false);
  };
  const {
    mutate: addRate,
    status: RateStatus,
    data: RateData,
    error: errorRate,
  } = POST_REQUEST({
    request: (data) =>
      USeInsertData("add_course_rate", data, {
        Authorization: `Bearer ${token}`,
      }),
    handelSuccessData,
  });
  function handelSuccessData(data) {}
  const {
    isLoading: LoadRateCourse,
    data: dataLoadRateCourse,
  } = GET_REQUEST({
    queryKey: "RateCourse2",
    request: () => UseGetData("get_course_raters", { id: id }),
    enabled: true,
    intervalRefetch: 1000,
    onResault,
  });
  function onResault() {
    setTimeout(() => {
      setShow(true);
    }, 250);
  }
  return (
    <Section>
      <Content>
        <Slide bottom cascade>
          <RightSection>
            {!LoadRateCourse && dataLoadRateCourse ? (
              <>
                <RateText>
                  {Math.ceil(dataLoadRateCourse?.data.data.rate) + ",0"}
                </RateText>
                <TitleRaeteng>
                  <RatingComponent
                    readOnly={true}
                    value={Math.ceil(dataLoadRateCourse?.data.data.rate)}
                  />
                  ({dataLoadRateCourse?.data?.data?.number_of_rater})
                </TitleRaeteng>
              </>
            ) : (
              ""
            )}
          </RightSection>
        </Slide>
        <LeftSection>
          {!LoadRateCourse && dataLoadRateCourse ? (
            <>
              <div
                style={{
                  display: show ? "none" : "block",
                  opacity: show ? "0" : "0.8",
                  transition: "opacity 200ms , display 200ms",
                }}
              >
                <Fade>
                  <CompRating>
                    <StudImage>
                      <Image src={`${process.env.REACT_APP_BASE_URL}${img}`} />
                      <TextDiscretion>{userName}</TextDiscretion>
                    </StudImage>
                    <TitleRaeteng style={{ flexDirection: "row" }}>
                      <RatingComponent readOnly={true} value={dataSub.rate} />
                      جاري التقيم....
                    </TitleRaeteng>
                    `` <RateDisc>{dataSub.commit}</RateDisc>
                  </CompRating>
                </Fade>
              </div>
              {dataLoadRateCourse?.data.data.rates
                .sort((b, a) => a.id - b.id)
                .map((el) => (
                  <Slide bottom cascade key={el.id}>
                    <CompRating>
                      <StudImage>
                        {el.image_path ? (
                          <Image
                            src={`${process.env.REACT_APP_BASE_URL}${el.image_path}`}
                          />
                        ) : (
                          <Image src={stud1} />
                        )}
                        <TextDiscretion>{el.user_name}</TextDiscretion>
                      </StudImage>
                      <TitleRaeteng style={{ flexDirection: "row" }}>
                        <RatingComponent readOnly={true} value={el.rataing} />
                        {el.date_of_create}
                      </TitleRaeteng>
                      <RateDisc>{el.comment}</RateDisc>
                    </CompRating>
                  </Slide>
                ))
                .slice(0, num)}
            </>
          ) : (
            <Dots />
          )}
          {!LoadRateCourse && dataLoadRateCourse ? (
            num >= dataLoadRateCourse.data?.data?.rates.length ? (
              <ButtonBase style={{ width: "300px" }} onClick={() => setNum(5)}>
                تصغير
                <img
                  src={Down}
                  alt=""
                  style={{ transform: "rotate(3.142rad)" }}
                />
              </ButtonBase>
            ) : (
              <ButtonBase
                style={{ width: "300px" }}
                onClick={() => setNum((prev) => prev + 5)}
              >
                رؤية المزيد
                <img src={Down} alt="" />
              </ButtonBase>
            )
          ) : null}
        </LeftSection>
      </Content>
      <Formik
        initialValues={formikProps.initialValues}
        validationSchema={formikProps.validationSchema}
        onSubmit={onSubmit}
        render={({ handleChange, handleBlur, values, errors, touched }) => (
          <Form style={{ width: "100%", bottom: "0" }}>
            <Zoom>
              <FormStyle>
                <RatingComponent
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.rating}
                  // error={errors.rating && touched.rating}
                  // errorText={errors.rating && touched.rating ? errors.rating : null}
                  name="rating"
                  // onChange={(event, newValue) => {
                  //     (newValue)
                  // }}
                />
                <InputFailForm
                  onChange={(e) => [handleChange(e)]}
                  onBlur={handleBlur}
                  // value={values.comment}

                  error={errors.comment && touched.comment}
                  errorText={
                    errors.comment && touched.comment ? errors.comment : null
                  }
                  name="comment"
                  placeholder="أدخل تعليقك هنا..."
                  inputProps={inputSearchProps}
                  borderradius="5px"
                />
              </FormStyle>
            </Zoom>
          </Form>
        )}
      />
    </Section>
  );
};

export default RatingCourse;
